import {
  IStore,
  ProblemDestination,
  RecommendationContext,
  TripAction,
  AlternativesMutationObj,
  SavedTrip,
  ProblmSubmissionRoute,
  AlternativeActivityAction,
  NearbyTripOptions,
  MinRecommendation,
  BudgetPreferences,
  TripIntent,
} from './global.types';
import {Module} from 'vuex';
import {IRootStore} from '../root/root-store.type';
import {FilterTag, TripOption, SuggestionGroup, SuggestionPois} from '@/views/amex/app-types';

import {downloadDomains} from '../api/download-domains';
import {downloadRecommendationContent} from '../api/download-recomendation-content';
import {buildProblemDestination, buildUserProfile} from '../api/build-problem';
import {Dictionary} from 'vue-router/types/router';
import {ISolutionVersion, submitAmexProblem, TravelersIndormation} from '../api/submit-amex-problem';
import {getUserId} from '@/services/auth';
import {
  ISolution,
  Price,
  UserActivityCategoryEnum,
  Activity,
  CurrencyCode,
  IProblem,
  getBeginningOfTheDay,
  CandidatePoiItem,
} from '@mobi-components/global-solution';
import {submitAmexAdditionalActivitiesProblem} from '../api/submit-additional-activities';
import {fixSolutionDates, fixDate} from './fix-solution-dates';

import {removePOI} from '../api/remove-poi';
import {loadSourcePOI} from '../api/load-source-poi';
import {SubscriptionLevel, ExtendedSolutionResponse, SolutionResponse} from '../solution/solution-support.types';
import {
  TripWithPois,
  mapCandidatePoiItemToTripOption,
  downloadDestinationTrips,
  downloadDestinationTripsByProblem,
  Trip,
  RecommendationsContext,
  TripsWithExplanations,
} from '../api/download-destination-trips';
import {SelectOptions} from '../api/load-alternatives';
import {loadAlternativeRecommendations} from '../api/load-alternative-recommendations';
import {submitAlternativeActivity} from '../api/submit-amex-alternative';
// import {checkSolutionSustanability} from './check-solution-sustanability';
import {mapAttributes} from '../api/download-recommendations';
import {downloadDestinationAlternatives} from '../api/download-destination-alternatives';
import {BudgetFilterValue, budgetDefultValue} from '@mobi-components/amex-bluesky-components';
import {IRescheduleActivityRequest, rescheduleActivity} from '../api/reschedule-activity';
import {resceduleSolution} from '../api/rescedule-solution';
import {saveSolutionToMyTrips} from '../api/save-solution-to-my-trips';
import {submitProblem} from '../solution/get-problem.action';
import {restoreSolutionsByUserId} from '@/store/api/get-saved-solutions';
import {updateBookingStatus} from '../api/update-booking-status';
import {toggleFlightHotel} from '../api/toggle-flight-hotel';
import {travlersDefaultValue, TravelersFilterValue} from '@common/travelers-filter/travelers.types';
import {TripFocus, tripCategoryTagsList, tripFocusTagList} from '@common/filter/trip-category-filter/trip-options';
import {AmexProblemUpdatePreferences, updateProblemPreferencesApi} from '../api/update-problem-preferences';
import {getAllSolutionFilters, getTravelersInformation} from './helpers';
import {AmexProblemUpdateTravelers, updateProblemTravelersInfoApi} from '../api/update-problem-travelers';
import {defaultDestination, defaultOrigin, fallbackImgs, initialState} from './initial-state';
import {AdditionalPoisModule, ChatHistoryModule, ItineraryPreferencesModule} from '../modules';
import {ItineraryListModule} from '../modules/itinerary-list';
import {RecommendationsContextWithOffers} from '@/views/amex/app-types';

const namespaced = true;
const PRESELECTED_TAGS = [...tripFocusTagList[TripFocus.POPULAR]];

export enum StoreGetters {
  GET_DEFAULT_IMAGES = 'GET_DEFAULT_IMAGES',
  GET_IS_RECOMMENDATIONS_LOADING = 'GET_IS_RECOMMENDATIONS_LOADING',
  GET_SOLUTION_RECOMMENDATIONS = 'GET_SOLUTION_RECOMMENDATIONS',
  GET_RECOMMENDATIONS_BLACKLIST = 'GET_RECOMMENDATIONS_BLACKLIST',
  GET_SOLUTION_VERSIONS = 'GET_SOLUTION_VERSIONS',
  GET_FIRST_DEST = 'GET_FIRST_DEST',
  GET_NEARBY_LOCATIONS = 'GET_NEARBY_LOCATIONS',
  GET_IS_DEST_AVAILABLE = 'GET_IS_DEST_AVAILABLE',
  GET_DEST_OPTIONS = 'GET_DEST_OPTIONS',
  GET_MISSING_FILTERS = 'GET_MISSING_FILTERS',
  GET_BOOKED_ACTIVITIES = 'GET_BOOKED_ACTIVITIES',
  GET_INTERSECTIONAL_FILTERS = 'GET_INTERSECTIONAL_FILTERS',
  IS_SOLUTION_UNDERCONSTRAINED = 'IS_SOLUTION_UNDERCONSTRAINED',
  GET_ORIGIN = 'GET_ORIGIN',
  GET_DESTINATION = 'GET_DESTINATION',
  GET_RECOMMENDATION_LOCATIONS = 'GET_RECOMMENDATION_LOCATIONS',
  GET_RECOMMENDATION_DETAILS = 'GET_RECOMMENDATION_DETAILS',
  GET_RECOMMENDATION_DETAILS_AVAILABILITY = 'GET_RECOMMENDATION_DETAILS_AVAILABILITY',
  GET_FAVORITE_TRIPS = 'GET_FAVORITE_TRIPS',
  GET_SOLUTION = 'GET_SOLUTION',
  GET_SELECTED_GEO = 'GET_SELECTED_GEO',
  GET_ALTERNATIVES = 'GET_ALTERNATIVES',
  GET_ALL_ALTERNATIVES = 'GET_ALL_ALTERNATIVES',
  GET_MY_TRIPS = 'GET_MY_TRIPS',
  GET_MANUAL_ACTIVITIES = 'GET_MANUAL_ACTIVITIES',
  GET_USED_FILTERS = 'GET_USED_FILTERS',
  GET_TRIP_CONTEXT = 'GET_TRIP_CONTEXT',
  GET_CONTEXT_TIMEZONE = 'GET_CONTEXT_TIMEZONE',
  GET_SOLUTION_TIMEZONE = 'GET_SOLUTION_TIMEZONE',
  GET_SESSION_ID = 'GET_SESSION_ID',
  GET_SOLUTION_COST = 'GET_SOLUTION_COST',
  GET_SOLUTION_CONTEXT = 'GET_SOLUTION_CONTEXT',
  GET_ALL_RECOMMENDATIONS_CONTENT = 'GET_ALL_RECOMMENDATIONS_CONTENT',
  GET_START_END_DATES = 'GET_START_END_DATES',
  GET_SOLUTION_START_END_VALUES = 'GET_SOLUTION_START_END_VALUES',
  GET_SOURCE_POI = 'GET_SOURCE_POI',
  GET_FLIGHT_OPTIONS = 'GET_FLIGHT_OPTIONS',
  GET_TRIP_PRICE = 'GET_TRIP_PRICE',
  GET_TRIP_THEMES = 'GET_TRIP_THEMES',
  GET_TRIP_ID = 'GET_TRIP_ID',
  GET_TRAVELERS = 'GET_TRAVELERS',
  GET_TRAVELERS_STRING = 'GET_TRAVELERS_STRING',
  GET_TRAVELERS_INFORMATION = 'GET_TRAVELERS_INFORMATION',
  GET_SOLUTION_IMG = 'GET_SOLUTION_IMG',
  GET_DEST_NAME = 'GET_DEST_NAME',
  GET_THEME_TRIPS = 'GET_THEME_TRIPS',
  GET_ACTIVE_SOLUTION_FILTERS = 'GET_ACTIVE_SOLUTION_FILTERS',
  GET_ALL_SELECTED_FILTERS = 'GET_ALL_SELECTED_FILTERS',
  GET_ALL_SOLUTION_FILTERS = 'GET_ALL_SOLUTION_FILTERS',
  GET_IS_SOLUTION_SUSTANABLE = 'GET_IS_SOLUTION_SUSTANABLE',
  GET_BUDGET = 'GET_BUDGET',
  GET_TAGS_FOR_ROUTE = 'GET_TAGS_FOR_ROUTE',
  GET_PRICE_BUDGET = 'GET_PRRICE_BUDGET',
  GET_AVAILABLE_TRIP_OPTIONS = 'GET_AVAILABLE_TRIP_OPTIONS',
  GET_SELECTED_THEME = 'GET_SELECTED_THEME',
  GET_SOLUTION_NAME = 'GET_SOLUTION_NAME',
  GET_DISPLAY_FLIGHTS = 'GET_DISPLAY_FLIGHTS',
  GET_DISPLAY_HOTELS = 'GET_DISPLAY_HOTELS',
  GET_SOLUTION_CONTEXTS = 'GET_SOLUTION_CONTEXTS',
  GET_TRIP_NAME = 'GET_TRIP_NAME',
  GET_TRIP_HIGHLIGHTS = 'GET_TRIP_HIGHLIGHTS',
  GET_HIGHLIGHTS_NAME = 'GET_HIGHLIGHTS_NAME',
  GET_TRIP_CATEGORY = 'GET_TRIP_CATEGORY',
  GET_TRIP_FOCUS = 'GET_TRIP_FOCUS',
  GET_TRIP_TYPE = 'GET_TRIP_TYPE',
  GET_DINING_ACTIVITIES = 'GET_DINING_ACTIVITIES',
  GET_EXPERIENCE_ACTIVITIES = 'GET_EXPERIENCE_ACTIVITIES',
  GET_BUDGET_PREFERENCES = 'GET_BUDGET_PREFERENCES',
  GET_SOLUTION_LOADING = 'GET_SOLUTION_LOADING',
}

export enum StoreActions {
  UPDATE_BOOKING_STATUS = 'UPDATE_BOOKING_STATUS',
  LOAD_DOMAIN_TAGS = 'LOAD_DOMAIN_TAGS',
  TOGGLE_SOLUTION_TAGS = 'TOGGLE_SOLUTION_TAGS',
  UPDATE_ORIGIN = 'UPDATE_ORIGIN',
  UPDATE_DESTINATION = 'UPDATE_DESTINATION',
  DECIDE_ON_RECOMMENDATIONS_LOADING = 'DECIDE_ON_RECOMMENDATIONS_LOADING',
  LOAD_TRIP_OPTIONS = 'LOAD_TRIP_OPTIONS',
  DROP_TRIP_OPTIONS = 'DROP_TRIP_OPTIONS',
  LOAD_TRIP_OPTIONS_BY_PROBLEM = 'LOAD_TRIP_OPTIONS_BY_PROBLEM',
  UPDATE_TRIP_PREFERENCES = 'UPDATE_TRIP_PREFERENCES',
  UPDATE_TRIP_TRAVELERS = 'UPDATE_TRIP_TRAVELERS',
  LOAD_NEARBY_PLACES = 'LOAD_NEARBY_PLACES',
  LOAD_RECOMMENDATION_DETAILS = 'LOAD_RECOMMENDATION_DETAILS',
  SELECT_TRIP = 'SELECT_TRIP',
  DROP_SELECTIONS = 'DROP_SELECTIONS',
  DROP_SOLUTION = 'DROP_SOLUTION',
  DROP_FAVORITES = 'DROP_FAVORITES',
  RESET_FILTERS = 'RESET_FILTERS',
  ADD_FAVORITE = 'ADD_FAVORITE',
  REMOVE_POI = 'REMOVE_POI',
  SUBMIT_PROBLEM = 'SUBMIT_PROBLEM',
  UPDATE_INTERSECTIONAL_FILTERS = 'GET_INTERSECTIONAL_FILTERS',
  LOAD_ALTERNATIVES = 'LOAD_ALTERNATIVES',
  SELECT_ALTERNATIVE = 'SELECT_ALTERNATIVE',
  ADD_MANUAL_ACTIVITY = 'ADD_MANUAL_ACTIVITY',
  DROP_MANUAL_ACTIVITIES = 'DROP_MANUAL_ACTIVITIES',
  LOAD_SOURCE_POI = 'LOAD_SOURCE_POI',
  SET_TRIP_PRICE = 'SET_TRIP_PRICE',
  UPDATE_GROUP_BUDGET = 'UPDATE_GROUP_BUDGET',
  UPDATE_SOLUTION_TRAVELERS = 'UPDATE_SOLUTION_TRAVELERS',
  UPDATE_DEST_BUDGET = 'UPDATE_DEST_BUDGET',
  UPDATE_SOLUTION_IMG = 'UPDATE_SOLUTION_IMG',
  UPDATE_DEST_NAME = 'UPDATE_DEST_NAME',
  UPDATE_SOLUTION_DATES = 'UPDATE_SOLUTION_DATES',
  UPDATE_SELECTED_SOLUTION_FILTERS = 'UPDATE_SELECTED_SOLUTION_FILTERS',
  UPDATE_SOLUTION_BUDGET = 'UPDATE_SOLUTION_BUDGET',
  SET_TRIP_CONTEXT = 'SET_TRIP_CONTEXT',
  // CHECK_PROBLEM = 'CHECK_PROBLEM',
  RESCHEDULE_ACTIVITY = 'RESCHEDULE_ACTIVITY',
  SET_AVAILABLE_TRIP_OPTIONS = 'SET_AVAILABLE_TRIP_OPTIONS',
  SET_SELECTED_THEME = 'SET_SELECTED_THEME',
  SET_SOLUTION = 'SET_SOLUTION',
  RESCHEDULE_SOLUTION = 'RESCHEDULE_SOLUTION',
  RESTORE_TRIP = 'RESTORE_TRIP',
  BLACK_LIST_RECOMMENDATION = 'BLACK_LIST_RECOMMENDATION',
  FETCH_MY_TRIPS = 'FETCH_MY_TRIPS',
  DROP_MY_TRIPS = 'DROP_MY_TRIPS',
  REMOVE_MISSING_FILTER = 'REMOVE_MISSING_FILTER',
  SET_MISSING_FILTERS = 'SET_MISSING_FILTERS',
  SAVE_SOLUTION = 'SAVE_SOLUTION',
  UPDATE_SOLUTION_NAME = 'UPDATE_SOLUTION_NAME',
  TOGGLE_FLIGHT_OR_STAY = 'TOGGLE_FLIGHT_OR_STAY',
  TOGGLE_TRIP_TYPE = 'TOGGLE_TRIP_TYPE',
  UPDATE_TRIP_CATEGORY = 'UPDATE_TRIP_CATEGORY',
  UPDATE_TRIP_FOCUS = 'UPDATE_TRIP_FOCUS',
  UPDATE_BUDGET_PREFERENCES = 'UPDATE_BUDGET_PREFERENCES',
  UPDATE_SOLUTON_LOADING_STATE = 'UPDATE_SOLUTON_LOADING_STATE',
  LOAD_RECOMMENDATION_ALTERNATIVES = 'LOAD_RECOMMENDATION_ALTERNATIVES',
}

export enum StoreMutations {
  UPDATE_DOMAIN_TAGS = 'UPDATE_DOMAIN_TAGS',
  SET_BOOKING_STATUS = 'SET_BOOKING_STATUS',
  TOGGLE_SOLUTION_TAG = 'TOGGLE_SOLUTION_TAG',
  TOGGLE_DESTINATION_TAG = 'TOGGLE_DESTINATION_TAG',
  UPDATE_ORIGIN = 'UPDATE_ORIGIN',
  UPDATE_DESTINATION = 'UPDATE_DESTINATION',
  SAVE_THEME_TRIPS = 'SAVE_THEME_TRIPS',
  SAVE_RECOMMENDATION_DETAILS = 'SAVE_RECOMMENDATION_DETAILS',
  SAVE_SELECTED_TRIP = 'SAVE_SELECTED_TRIP',
  ADD_FAVORITE = 'ADD_FAVORITE',
  SAVE_SOLUTION = 'SAVE_SOLUTION',
  UPDATE_SOLUTON_LOADING_STATE = 'UPDATE_SOLUTON_LOADING_STATE',
  ADD_SOLUTION_TO_TRIP = 'ADD_SOLUTION_TO_TRIP',
  DROP_SELECTIONS = 'DROP_SELECTIONS',
  DROP_FAVORITES = 'DROP_FAVORITES',
  RESET_FILTERS = 'RESET_FILTERS',
  SAVE_ALTERNATIVES = 'SAVE_ALTERNATIVES',
  SAVE_MANUAL_ACTIVITY = 'SAVE_MANUAL_ACTIVITY',
  DROP_MANUAL_ACTIVITIES = 'DROP_MANUAL_ACTIVITIES',
  SAVE_SOURCE_POI = 'SAVE_SOURCE_POI',
  SAVE_SOLUTION_VERSIONS = 'SAVE_SOLUTION_VERSIONS',
  SET_SOLUTION_RECOMMENDATIONS_LOADING = 'SET_SOLUTION_RECOMMENDATIONS_LOADING',
  SAVE_TRIP_PRICE = 'SAVE_TRIP_PRICE',
  SAVE_TRIP_THEMES = 'SAVE_TRIP_THEMES',
  UPDATE_GROUP_BUDGET = 'UPDATE_GROUP_BUDGET',
  UPDATE_SOLUTION_TRAVELERS = 'UPDATE_SOLUTION_TRAVELERS',
  UPDATE_DEST_BUDGET = 'UPDATE_DEST_BUDGET',
  UPDATE_SOLUTION_IMG = 'UPDATE_SOLUTION_IMG',
  UPDATE_DEST_NAME = 'UPDATE_DEST_NAME',
  UPDATE_SOLUTION_DATES = 'UPDATE_SOLUTION_DATES',
  UPDATE_SELECTED_SOLUTION_FILTERS = 'UPDATE_SELECTED_SOLUTION_FILTERS',
  UPDATE_SOLUTION_BUDGET = 'UPDATE_SOLUTION_BUDGET',
  SET_TRIP_CONTEXT = 'SET_TRIP_CONTEXT',
  SET_SOLUTION_EVALUATION = 'SET_SOLUTION_EVALUATION',
  SAVE_DEST_OPTIONS = 'SAVE_DEST_OPTIONS',
  DROP_DEST_OPTIONS = 'DROP_DEST_OPTIONS',
  SAVE_NEARBY_LOCATIONS = 'SAVE_NEARBY_LOCATIONS',
  SET_AVAILABLE_TRIP_OPTIONS = 'SET_AVAILABLE_TRIP_OPTIONS',
  SET_SELECTED_THEME = 'SET_SELECTED_THEME',
  BLACK_LIST_RECOMMENDATION = 'BLACK_LIST_RECOMMENDATION',
  SET_MY_TRIPS = 'SET_MY_TRIPS',
  REMOVE_MISSING_FILTER = 'REMOVE_MISSING_FILTER',
  SET_MISSING_FILTERS = 'SET_MISSING_FILTERS',
  UPDATE_SOLUTION_NAME = 'UPDATE_SOLUTION_NAME',
  TOGGLE_TRIP_TYPE = 'TOGGLE_TRIP_TYPE',
  UPDATE_TRIP_CATEGORY = 'UPDATE_TRIP_CATEGORY',
  UPDATE_TRIP_FOCUS = 'UPDATE_TRIP_FOCUS',
  UPDATE_BUDGET_PREFERENCES = 'UPDATE_BUDGET_PREFERENCES',
  SAVE_INTERSECTIONAL_FILTERS = 'UPDATE_INTERSECTIONAL_FILTERS',
}

export const getPoisFromRecommendations = (
  recommendationDetails: Dictionary<SuggestionPois[]>,
): RecommendationsContextWithOffers[] => {
  const stays = (recommendationDetails[UserActivityCategoryEnum.ACCOMMODATION] || [])
    .map((x) => x?.pois || [])
    .flat()
    .map((x) => ({
      ...x,
      context: UserActivityCategoryEnum.ACCOMMODATION,
    }));

  const dine = (recommendationDetails[UserActivityCategoryEnum.DINING] || [])
    .map((x) => x?.pois || [])
    .flat()
    .map((x) => ({
      ...x,
      context: UserActivityCategoryEnum.DINING,
    }));
  const explore = (recommendationDetails[UserActivityCategoryEnum.EXPERIENCE] || [])
    .map((x) => x?.pois || [])
    .flat()
    .map((x) => ({
      ...x,
      context: UserActivityCategoryEnum.EXPERIENCE,
    }));

  return [...stays, ...dine, ...explore];
};

export const mainModule: Module<IStore, IRootStore> = {
  namespaced,
  state: initialState,
  modules: {
    ChatHistory: ChatHistoryModule,
    AdditionalPois: AdditionalPoisModule,
    ItineraryPreferences: ItineraryPreferencesModule,
    ItineraryList: ItineraryListModule,
  },
  getters: {
    [StoreGetters.GET_BOOKED_ACTIVITIES]: (state) => {
      return state?.bookedActivities || {};
    },
    [StoreGetters.GET_INTERSECTIONAL_FILTERS]: (state) => {
      return {
        [UserActivityCategoryEnum.ACCOMMODATION]: state[UserActivityCategoryEnum.ACCOMMODATION],
        [UserActivityCategoryEnum.DINING]: state[UserActivityCategoryEnum.DINING],
        [UserActivityCategoryEnum.EXPERIENCE]: state[UserActivityCategoryEnum.EXPERIENCE],
      };
    },
    [StoreGetters.GET_DISPLAY_FLIGHTS]: (state) => {
      if (!state?.solutionResponse) {
        return true;
      }
      return state?.solutionResponse?.display?.display_flights || false;
    },
    [StoreGetters.GET_DISPLAY_HOTELS]: (state) => {
      if (!state?.solutionResponse) {
        return true;
      }
      return state?.solutionResponse?.display?.display_accommodations || false;
    },
    [StoreGetters.GET_DINING_ACTIVITIES]: (state) => {
      return (
        state?.solutionResponse?.solution?.activities.filter(
          (activity) => activity.category === UserActivityCategoryEnum.DINING,
        ) || []
      );
    },
    [StoreGetters.GET_EXPERIENCE_ACTIVITIES]: (state) => {
      return (
        state?.solutionResponse?.solution?.activities.filter(
          (activity) => activity.category === UserActivityCategoryEnum.EXPERIENCE,
        ) || []
      );
    },
    [StoreGetters.GET_BUDGET_PREFERENCES]: (state) => {
      return state?.budgetPreferences || {};
    },
    [StoreGetters.GET_SOLUTION_NAME]: (state) => {
      return state?.solutionName || '';
    },
    [StoreGetters.GET_SOLUTION_LOADING]: (state) => {
      return state?.isSolutionLoading || !state.solutionResponse;
    },
    [StoreGetters.GET_TRIP_HIGHLIGHTS]: (state) => {
      const pois = state?.solutionResponse?.highlights?.pois || [];
      const activities = (state?.solutionResponse?.highlights?.activities || [])
        .map((x) => x.source?.content)
        .filter(Boolean);
      return pois.length ? pois : activities;
    },
    [StoreGetters.GET_HIGHLIGHTS_NAME]: (state) => {
      return state?.solutionResponse?.highlights?.title || '';
    },
    [StoreGetters.GET_DEFAULT_IMAGES]: (state) => {
      return state.fallbackImgs || fallbackImgs;
    },
    [StoreGetters.GET_MISSING_FILTERS]: (state) => {
      const filters = state?.initiallySelectedFilters || [];
      const existingFilters = new Set(state.availableSolutionFilters.map((x) => x.id));
      return filters.filter((x) => !existingFilters.has(x.id));
    },
    [StoreGetters.GET_AVAILABLE_TRIP_OPTIONS]: (state) => {
      return state?.availableTripOptions || [];
    },
    [StoreGetters.GET_IS_RECOMMENDATIONS_LOADING]: (state) => {
      return state?.isRecommendationsLoading;
    },
    [StoreGetters.GET_SOLUTION_RECOMMENDATIONS]: (state, getters) => {
      const blackListed = state?.recommendationsBlackList || new Set();
      const solution: ISolution | null = getters[StoreGetters.GET_SOLUTION];
      return (solution?.activities || []).filter((x) => {
        return x.spec?.curated && x.source?.content && !blackListed.has(x.source.content.id);
      });
    },
    [StoreGetters.GET_RECOMMENDATIONS_BLACKLIST]: (state) => {
      return state?.recommendationsBlackList || new Set();
    },
    [StoreGetters.GET_SELECTED_THEME]: (state) => {
      return state?.selectedTheme || '';
    },
    [StoreGetters.GET_FIRST_DEST]: (state): TripOption | null => {
      return state?.nearbyLocations?.contexts?.length ? state.nearbyLocations.contexts[0] : null;
    },
    [StoreGetters.GET_DEST_OPTIONS]: (state): Record<string, Trip[]> => {
      return state?.destOptions;
    },
    [StoreGetters.GET_NEARBY_LOCATIONS]: (state): TripOption[] => {
      return state?.nearbyLocations?.contexts || [];
    },
    [StoreGetters.GET_IS_DEST_AVAILABLE]: (state): boolean => {
      return state?.nearbyLocations?.isDestAvailable || false;
    },
    [StoreGetters.GET_IS_SOLUTION_SUSTANABLE]: (state): boolean => {
      return state?.isSolutionSustanable || false;
    },
    [StoreGetters.GET_ALL_SOLUTION_FILTERS]: (state): FilterTag[] => {
      return state?.availableSolutionFilters || [];
    },
    [StoreGetters.GET_ACTIVE_SOLUTION_FILTERS]: (state): FilterTag[] => {
      const hash = (state?.selectedSolutionFilters || []).reduce((r: Record<string, boolean>, x) => {
        r[x.id] = true;
        return r;
      }, {});

      return state?.availableSolutionFilters.map((x) => ({...x, value: Boolean(hash[x.id])}));
    },
    [StoreGetters.GET_ALL_SELECTED_FILTERS]: (state): FilterTag[] => {
      return state.selectedSolutionFilters;
    },
    [StoreGetters.GET_BUDGET]: (state): ((route: ProblmSubmissionRoute) => BudgetFilterValue) => {
      return () => {
        return state.solutionBudget || {...budgetDefultValue};
      };
    },
    [StoreGetters.GET_TAGS_FOR_ROUTE]: (state, getters): ((route: ProblmSubmissionRoute) => FilterTag[]) => {
      return (/* route */) => {
        const availableTags: FilterTag[] = getters[StoreGetters.GET_ACTIVE_SOLUTION_FILTERS];

        return availableTags;
      };
    },
    [StoreGetters.GET_PRICE_BUDGET]: (_, getters): ((route: ProblmSubmissionRoute) => Price[]) => {
      return (route) => {
        const budget: BudgetFilterValue = getters[StoreGetters.GET_BUDGET](route);
        const stayBudget =
          budget.stay === budgetDefultValue.stay
            ? null
            : {
                amount: budget.stay,
                currency: CurrencyCode.USD,
                category: UserActivityCategoryEnum.ACCOMMODATION,
              };
        const flightBudget =
          budget.flight === budgetDefultValue.flight
            ? null
            : {
                amount: budget.flight,
                currency: CurrencyCode.USD,
                category: UserActivityCategoryEnum.TRANSPORTATION,
              };
        const dineBudget =
          budget.dine === budgetDefultValue.dine
            ? null
            : {
                amount: budget.dine,
                currency: CurrencyCode.USD,
                category: UserActivityCategoryEnum.DINING,
              };
        const experienceBudget =
          budget.experience === budgetDefultValue.experience
            ? null
            : {
                amount: budget.experience,
                currency: CurrencyCode.USD,
                category: UserActivityCategoryEnum.EXPERIENCE,
              };

        return [stayBudget, flightBudget, dineBudget, experienceBudget].filter(Boolean) as Price[];
      };
    },
    [StoreGetters.GET_TRAVELERS]: (state) => {
      const def = {
        ...travlersDefaultValue,
        filter: {
          ...travlersDefaultValue.filter,
          adults: '1 Adult',
        },
      };
      const travelers = state.solutionTravelers;
      if (
        travelers &&
        travelers.filter.adults === travlersDefaultValue.filter.adults &&
        travelers.filter.children === travlersDefaultValue.filter.children &&
        travelers.filter.rooms === travlersDefaultValue.filter.rooms
      ) {
        return def;
      }
      return travelers || def;
    },
    [StoreGetters.GET_TRAVELERS_STRING]: (state, getters) => {
      const tr = getters[StoreGetters.GET_TRAVELERS].filter;
      const travelers: string[] = Object.keys(tr)
        .map((x) => tr[x])
        .filter((x) => x !== 'Add' && x !== 'Select');
      return travelers;
    },
    [StoreGetters.GET_TRAVELERS_INFORMATION]: (state, getters) => {
      const tr: TravelersFilterValue = getters[StoreGetters.GET_TRAVELERS];
      const travelersInformation: TravelersIndormation = {
        adults:
          !tr.filter?.adults || tr.filter?.adults === travlersDefaultValue.filter.adults
            ? 1
            : parseInt(tr.filter?.adults, 10),
        rooms:
          !tr.filter?.rooms || tr.filter?.rooms === travlersDefaultValue.filter.rooms
            ? 1
            : parseInt(tr.filter?.rooms, 10),

        children: Object.keys(tr.age)
          // @ts-ignore
          .map((key: string) => parseInt(tr.age[key], 10))
          .filter((x) => !isNaN(x)).length,
        child_ages: Object.keys(tr.age)
          // @ts-ignore
          .map((key: string) => parseInt(tr.age[key], 10))
          .filter((x) => !isNaN(x)),
        infants: Object.keys(tr.age)
          // @ts-ignore
          .map((key: string) => parseInt(tr.age[key], 10))
          .filter((x) => isNaN(x)).length,
        // @ts-ignore
        infant_types: Object.keys(tr.age)
          .map((key: string, index) => {
            // @ts-ignore
            if (isNaN(parseInt(tr.age[key], 10))) {
              return tr.seating[index] === 'In Seat' ? 'IN_SEAT' : 'IN_LAP';
            }
            return null;
          })
          .filter(Boolean),
      };
      return travelersInformation;
    },
    [StoreGetters.GET_TRIP_ID]: (state): string => {
      return state?.selectedTrip;
    },
    [StoreGetters.GET_TRIP_THEMES]: (state): SuggestionGroup[] => {
      return state?.tripSuggestions || [];
    },
    [StoreGetters.GET_TRIP_PRICE]: (state): Price[] => {
      return state?.tripPrice || [];
    },
    [StoreGetters.GET_SOLUTION_VERSIONS]: (state): Record<string, ISolutionVersion[]> => {
      return state?.alternativeSolutions || {};
    },
    [StoreGetters.GET_THEME_TRIPS]: (state): TripWithPois[] => {
      return state?.themeTrips || [];
    },
    [StoreGetters.GET_SOURCE_POI]: (state): RecommendationContext[] => {
      return state?.sourcePOIs || [];
    },
    [StoreGetters.GET_START_END_DATES]: (state) => {
      const start = state.solutionStart ? getBeginningOfTheDay(new Date(state.solutionStart)).valueOf() : 0;
      const end = state.solutionEnd ? getBeginningOfTheDay(new Date(state.solutionEnd)).valueOf() : 0;
      const days = 7;

      if (!start && !end) {
        const originDate = getBeginningOfTheDay(new Date(new Date().valueOf() + 2 * 24 * 3600 * 1000)).valueOf();
        const destDate = getBeginningOfTheDay(
          new Date(new Date().valueOf() + (2 + +days) * 24 * 3600 * 1000),
        ).valueOf();
        const s = originDate;
        const e = destDate;
        const res2 = {
          start: s,
          end: e,
        };
        return res2;
      }

      const adjustedStart = start;
      const adjustedEnd = end;
      const res4 = {
        start: adjustedStart,
        end: adjustedEnd,
      };
      return res4;
    },
    [StoreGetters.GET_SOLUTION_START_END_VALUES]: (state): {start: number; end: number} => {
      const start = state?.solutionStart || 0;
      const end = state?.solutionEnd || 0;
      return {
        start,
        end,
      };
    },
    [StoreGetters.GET_ALL_RECOMMENDATIONS_CONTENT]: (state): RecommendationContext[] => {
      const recommendationDetails = state.recommendationDetails || {};
      const additionalPois = AdditionalPoisModule.getPois();
      const pois = getPoisFromRecommendations(recommendationDetails);
      return [...pois, ...additionalPois];
    },
    [StoreGetters.GET_USED_FILTERS]: (state): string[] => {
      return state?.solutionResponse?.spec?.satisfied_filters || [];
    },
    [StoreGetters.GET_TRIP_NAME]: (state): string => {
      return state?.solutionResponse?.destination?.name || '';
    },
    [StoreGetters.IS_SOLUTION_UNDERCONSTRAINED]: (state): boolean => {
      return state?.solutionResponse?.spec?.subscription_level === SubscriptionLevel.UNDER_SUBSCRIBED;
    },
    [StoreGetters.GET_MANUAL_ACTIVITIES]: (state): RecommendationContext[] => {
      return state?.manualActivities || [];
    },
    [StoreGetters.GET_SELECTED_GEO]: (): string[] => {
      return getAllSolutionFilters()
        .filter((x) => x.domain === UserActivityCategoryEnum.GEOLOCATION && x.value)
        .map((x) => x.name);
    },
    [StoreGetters.GET_MY_TRIPS]: (state): SavedTrip[] => {
      return (state?.myTrips || []).map((x) => ({
        ...x,
        name: (x.name || '').replace(/_/g, ', '),
      }));
    },
    [StoreGetters.GET_FAVORITE_TRIPS]: (state) => (id: string) => (state?.favorites || {})[id],
    [StoreGetters.GET_ALTERNATIVES]: (state) => (id: string) => (state?.alternatives || {})[id],
    [StoreGetters.GET_ALL_ALTERNATIVES]: (state) => {
      const alt = state?.alternatives || {};
      return alt;
    },
    [StoreGetters.GET_SOLUTION]: (state) => state.solutionResponse?.solution || null,
    [StoreGetters.GET_ORIGIN]: (state): ProblemDestination | null => {
      return state?.origin || {...defaultOrigin};
    },
    [StoreGetters.GET_DESTINATION]: (state): ProblemDestination | null => {
      return state?.destination || {...defaultDestination};
    },
    [StoreGetters.GET_RECOMMENDATION_LOCATIONS]: (state): RecommendationsContext[] => {
      const selectedTrips: Trip[] = state?.availableTripOptions || [];
      const tripsForDestination = Object.keys(state?.destOptions || {})
        .map((key) => {
          return (state?.destOptions || {})[key];
        })
        .flat()
        .concat(selectedTrips)
        .map((x) => ({
          id: x.trip_id,
          location: x.context?.location,
          contextName: x.context?.name,
          context: x.context,
        }));
      const hash = new Set<string>();

      return tripsForDestination.filter((x) => {
        if (hash.has(x.id)) {
          return false;
        }
        hash.add(x.id);
        return true;
      });
    },
    [StoreGetters.GET_RECOMMENDATION_DETAILS]: (state): Dictionary<SuggestionPois[]> => {
      return state?.recommendationDetails || {};
    },
    [StoreGetters.GET_TRIP_CONTEXT]: (state): string => {
      return state?.tripContext || '';
    },
    [StoreGetters.GET_CONTEXT_TIMEZONE]: (state, {getters}): string => {
      const recommendation =
        getters[StoreGetters.GET_RECOMMENDATION_LOCATIONS].find(
          (x: RecommendationsContext) => x.id === state.selectedTrip,
        ) || null;
      return recommendation?.location?.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    [StoreGetters.GET_SOLUTION_TIMEZONE]: (state, getters): string => {
      const solution = getters[StoreGetters.GET_SOLUTION];
      if (!solution) {
        return '';
      }
      return state.solutionResponse?.destination?.time_zone || '';
    },
    [StoreGetters.GET_SOLUTION_CONTEXT]: (state): string => {
      return state.solutionResponse?.destination?.name || '';
    },
    [StoreGetters.GET_SOLUTION_CONTEXTS]: (state): CandidatePoiItem[] => {
      return state.solutionResponse?.spec?.contexts || [];
    },
    [StoreGetters.GET_SESSION_ID]: (state): string => {
      return state?.solutionResponse?.session_id || '';
    },
    [StoreGetters.GET_SOLUTION_IMG]: (state): string => {
      return state?.solutionImg || '';
    },
    [StoreGetters.GET_DEST_NAME]: (state): string => {
      return state?.destName || '';
    },
    [StoreGetters.GET_TRIP_CATEGORY]: (state): string => {
      return state?.tripCategory || '';
    },
    [StoreGetters.GET_TRIP_TYPE]: (state): string => {
      return state?.tripType || '';
    },
    [StoreGetters.GET_TRIP_FOCUS]: (state): string => {
      return state?.tripFocus || '';
    },
    [StoreGetters.GET_SOLUTION_COST]: (_, getters): Price[] => {
      const solution = getters[StoreGetters.GET_SOLUTION];
      if (!solution) {
        return [];
      }
      return solution.price;
    },
  },
  /////////////////////////////////////////////////////////
  actions: {
    [StoreActions.UPDATE_BOOKING_STATUS]: async ({commit, getters}, {activityId, status}) => {
      commit(StoreMutations.SET_BOOKING_STATUS, {activityId, status});
      const userId = getUserId();
      const sessionId = getters[StoreGetters.GET_SESSION_ID];
      const activities = await updateBookingStatus(userId, sessionId, activityId, status);
      if (activities.length === 0) {
        commit(StoreMutations.SET_BOOKING_STATUS, {activityId, status: !status});
      }
      activities.forEach(({id, booked}) => {
        commit(StoreMutations.SET_BOOKING_STATUS, {activityId: id, status: booked});
      });
    },
    [StoreActions.FETCH_MY_TRIPS]: async ({commit}) => {
      const userId = getUserId();

      const trips = userId ? await restoreSolutionsByUserId(userId, true) : [];

      const formattedTrips = trips
        .map((x) => {
          if (!x || !x.solution_response) {
            return null;
          }

          const included = new Set();
          const allowed = new Set([
            UserActivityCategoryEnum.ACCOMMODATION,
            UserActivityCategoryEnum.DINING,
            UserActivityCategoryEnum.EXPERIENCE,
          ]);

          // @ts-ignore
          const activities = x.solution_response.solution.activities.filter((y) => {
            if (!y?.category) {
              return false;
            }
            if (!allowed.has(y.category)) {
              return false;
            }
            if (y?.source?.candidate_id && included.has(y.source.candidate_id)) {
              return false;
            }
            if (y.spec?.curated) {
              return false;
            }
            included.add(y.source.candidate_id);
            return true;
          });

          const pref = x.problem?.profile?.preferences.filter((x) => x.category !== UserActivityCategoryEnum.TRAVELER);

          const destination = x.solution_response.destination;
          const preferences = (pref || []).map((y) => [...y.places, ...y.types]).flat();
          const destName = destination?.name.replaceAll('_', ', ');
          // @ts-ignore
          const destShortName = destination.name.split('_')[0];
          // @ts-ignore
          const destLocation = destination.name
            .replace(destShortName, '')
            .substring(1)
            .replaceAll('_', ', ');

          const preferencesCounts = x.selected_filters.reduce((acc, el) => {
            if (!el.name || el.category === UserActivityCategoryEnum.TRAVELER) {
              return acc;
            }
            // @ts-ignore
            if (acc[el.name]) {
              // @ts-ignore
              acc[el.name]++;
            } else {
              // @ts-ignore
              acc[el.name] = 1;
            }

            return acc;
          }, {});

          return {
            autoSaved: x.auto_saved,
            id: x.solution_response.session_id,
            tripId: x.trip_id,
            destination: destShortName,
            destLocation,
            activities,
            name: x.trip_name ? x.trip_name : 'Trip To ' + destName,
            images: [destination?.photo],
            img: destination?.photo,
            prefs: preferences,
            preferences: preferencesCounts,
            places: activities.length,
            prices: x?.solution_response?.solution?.price,
            theme: destName,
            scheduled_start_time: fixDate(x.trip_start_time, destination?.time_zone),
            scheduled_end_time: fixDate(x.trip_end_time, destination?.time_zone),
            tripContexts: x.trip_contexts || [],
          };
        })
        .filter(Boolean);

      commit(StoreMutations.SET_MY_TRIPS, formattedTrips);
    },
    [StoreActions.DROP_MY_TRIPS]: ({commit}) => {
      commit(StoreMutations.SET_MY_TRIPS, []);
    },
    [StoreActions.UPDATE_INTERSECTIONAL_FILTERS]: ({commit}, {category, filter}) => {
      commit(StoreMutations.SAVE_INTERSECTIONAL_FILTERS, {category, filter});
    },
    [StoreActions.LOAD_DOMAIN_TAGS]: async ({commit}, context) => {
      const domains = await downloadDomains(context);
      const all = domains
        .filter((x, index, self) => {
          const xIndex = self.findIndex((y) => y.name === x.name && x.domain === y.domain);
          return xIndex === index;
        })
        .map((tag) =>
          PRESELECTED_TAGS.find((preselectedTag) => preselectedTag.id === tag.id) ? {...tag, value: true} : tag,
        );

      commit(StoreMutations.UPDATE_DOMAIN_TAGS, all);

      return all;
    },
    [StoreActions.SET_TRIP_PRICE]: ({commit}, price: Price[]) => {
      commit(StoreMutations.SAVE_TRIP_PRICE, price);
    },
    [StoreActions.REMOVE_MISSING_FILTER]: ({commit}, id: string) => {
      commit(StoreMutations.REMOVE_MISSING_FILTER, id);
    },
    [StoreActions.SET_MISSING_FILTERS]: ({commit}, filters) => {
      commit(StoreMutations.SET_MISSING_FILTERS, filters);
    },
    [StoreActions.SET_AVAILABLE_TRIP_OPTIONS]: ({commit}, options: TripWithPois[]) => {
      commit(StoreMutations.SET_AVAILABLE_TRIP_OPTIONS, options);
    },
    [StoreActions.SET_SELECTED_THEME]: ({commit}, value: string) => {
      commit(StoreMutations.SET_SELECTED_THEME, value);
    },
    [StoreActions.UPDATE_SOLUTON_LOADING_STATE]: ({commit}, value: boolean) => {
      // commit(StoreMutations.UPDATE_SOLUTON_LOADING_STATE, true);
      commit(StoreMutations.UPDATE_SOLUTON_LOADING_STATE, value);
    },
    [StoreActions.SET_SOLUTION]: async ({commit}, value: ExtendedSolutionResponse) => {
      await ItineraryListModule.update(value.solution);
      commit(StoreMutations.SAVE_SOLUTION, {solution: value});
    },
    [StoreActions.RESTORE_TRIP]: async (
      {commit, state},
      {problem, tripName, tripId}: {problem: IProblem; tripName: string; tripId: string},
    ) => {
      try {
        const result = await submitProblem(problem);
        const updatedSolution = fixSolutionDates(result?.solution);
        await ItineraryListModule.update(updatedSolution);
        commit(
          StoreMutations.SAVE_SOLUTION,
          updatedSolution
            ? {solution: {...result, solution: updatedSolution, originalSolution: result.solution}}
            : {solution: state.solutionResponse},
        );
        if (result && result.session_id) {
          const userId = getUserId();
          saveSolutionToMyTrips(result.session_id, userId, problem.profile, tripName, true);
          commit(StoreMutations.UPDATE_SOLUTION_NAME, tripName);
        }
        commit(StoreMutations.ADD_SOLUTION_TO_TRIP, {tripId, solutionResponse: result});
        commit(StoreMutations.SAVE_SELECTED_TRIP, tripId);
      } catch {}
    },
    [StoreActions.DROP_SOLUTION]: async ({commit, state}, soft) => {
      const oldSolution = state.solutionResponse;
      await ItineraryListModule.update(null);
      commit(StoreMutations.SAVE_SOLUTION, {solution: null, soft});
      return oldSolution;
    },
    [StoreActions.UPDATE_SOLUTION_IMG]: ({commit}, url: string) => {
      commit(StoreMutations.UPDATE_SOLUTION_IMG, url);
    },
    [StoreActions.UPDATE_DEST_NAME]: ({commit}, name: string) => {
      commit(StoreMutations.UPDATE_DEST_NAME, name);
    },
    [StoreActions.UPDATE_SOLUTION_BUDGET]: ({commit}, budget: number) => {
      commit(StoreMutations.UPDATE_SOLUTION_BUDGET, budget);
    },
    [StoreActions.UPDATE_SOLUTION_TRAVELERS]: ({commit}, travelers) => {
      commit(StoreMutations.UPDATE_SOLUTION_TRAVELERS, travelers);
    },
    [StoreActions.UPDATE_GROUP_BUDGET]: ({commit}, budget: number) => {
      commit(StoreMutations.UPDATE_GROUP_BUDGET, budget);
    },
    [StoreActions.UPDATE_DEST_BUDGET]: ({commit}, budget: number) => {
      commit(StoreMutations.UPDATE_DEST_BUDGET, budget);
    },
    [StoreActions.LOAD_SOURCE_POI]: async ({commit}, sourceId: string) => {
      try {
        const poi = await loadSourcePOI(sourceId);
        commit(StoreMutations.SAVE_SOURCE_POI, poi);
        return poi;
      } catch {}
    },
    [StoreActions.TOGGLE_SOLUTION_TAGS]: ({commit}, tags: FilterTag[]) => {
      tags.forEach((tag) => {
        commit(StoreMutations.TOGGLE_SOLUTION_TAG, tag);
      });
    },
    [StoreActions.DROP_FAVORITES]: ({commit}, tripId?: string) => {
      commit(StoreMutations.DROP_FAVORITES, tripId);
    },
    [StoreActions.UPDATE_SOLUTION_DATES]: ({commit}, dates) => {
      commit(StoreMutations.UPDATE_SOLUTION_DATES, dates);
    },
    [StoreActions.UPDATE_SELECTED_SOLUTION_FILTERS]: ({commit}, filters: FilterTag[]) => {
      commit(StoreMutations.UPDATE_SELECTED_SOLUTION_FILTERS, filters);
    },
    [StoreActions.SET_TRIP_CONTEXT]: ({commit}, context: string) => {
      commit(StoreMutations.SET_TRIP_CONTEXT, context);
    },
    [StoreActions.DECIDE_ON_RECOMMENDATIONS_LOADING]: async ({dispatch}, {route, contextName}) => {
      dispatch(StoreActions.LOAD_RECOMMENDATION_DETAILS, {route, contextName});
    },
    [StoreActions.SUBMIT_PROBLEM]: async (
      {commit, state, getters, dispatch},
      {tripId, route, flights, mealPrefference, additionalContexts},
    ) => {
      const favorites = getters[StoreGetters.GET_FAVORITE_TRIPS](tripId) || [];
      const additionalActivities = getters[StoreGetters.GET_MANUAL_ACTIVITIES] || [];
      const knownActivities = getters[StoreGetters.GET_ALL_RECOMMENDATIONS_CONTENT];
      const additionalPois = AdditionalPoisModule.getPois();
      const allTrips = getters[StoreGetters.GET_RECOMMENDATION_LOCATIONS];
      const trip = allTrips.find((x: RecommendationsContext) => x.id === tripId);
      const contextName = getters[StoreGetters.GET_TRIP_CONTEXT];
      const tripContext = allTrips.find((x: RecommendationsContext) => x.contextName === contextName)?.context;
      const oldResponse = state.solutionResponse;
      const oldSolution = getters[StoreGetters.GET_SOLUTION];
      const oldSession = getters[StoreGetters.GET_SESSION_ID];
      const origin = getters[StoreGetters.GET_ORIGIN];
      const destination = getters[StoreGetters.GET_DESTINATION];
      const travelersInformation: TravelersIndormation = getters[StoreGetters.GET_TRAVELERS_INFORMATION];

      commit(StoreMutations.SET_TRIP_CONTEXT, trip?.contextName || contextName);
      const budget: Price[] = getters[StoreGetters.GET_PRICE_BUDGET](route);
      const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](route);
      let result = null;
      try {
        if (oldSolution && additionalActivities.length > 0) {
          result = await submitAmexAdditionalActivitiesProblem(
            oldSession,
            oldSolution,
            additionalActivities,
            [...knownActivities, ...additionalPois],
            mealPrefference,
          );
        } else {
          const {start, end} = getters[StoreGetters.GET_START_END_DATES];
          result = await submitAmexProblem(
            travelersInformation,
            tripId,
            tripContext,
            favorites,
            [],
            knownActivities,
            {...origin, departure_timestamp: start},
            {...destination, departure_timestamp: end},
            getUserId(),
            availableTags.filter((x) => x.value),
            start,
            end,
            budget,
            flights,
            additionalContexts,
          );
        }
        // commit(StoreMutations.UPDATE_SOLUTION_NAME, '');
        await dispatch(StoreActions.SAVE_SOLUTION, {tripId, result, needToSave: true});
      } catch (x) {
        console.error(x);
        await ItineraryListModule.update(oldResponse?.solution || null);
        commit(StoreMutations.SAVE_SOLUTION, {solution: oldResponse});
      } finally {
        commit(StoreMutations.DROP_MANUAL_ACTIVITIES);
        commit(StoreMutations.UPDATE_SOLUTON_LOADING_STATE, false);
      }
      commit(StoreMutations.UPDATE_SOLUTON_LOADING_STATE, false);
      return result;
    },
    [StoreActions.TOGGLE_FLIGHT_OR_STAY]: async ({commit, state, getters, dispatch}, {flight, stay, tripId}) => {
      const oldResponse = state.solutionResponse;
      const oldSession = getters[StoreGetters.GET_SESSION_ID];
      let result = null;

      try {
        result = await toggleFlightHotel(oldSession, flight, stay);
        await dispatch(StoreActions.SAVE_SOLUTION, {tripId, result, needToSave: true});
      } catch (x) {
        console.error(x);
        await ItineraryListModule.update(oldResponse?.solution || null);
        commit(StoreMutations.SAVE_SOLUTION, {solution: oldResponse});
      } finally {
        commit(StoreMutations.DROP_MANUAL_ACTIVITIES);
      }
      return result;
    },
    [StoreActions.SAVE_SOLUTION]: async (
      {commit, getters},
      {tripId, result, needToSave}: {tripId: string; result: SolutionResponse | null; needToSave: boolean},
    ) => {
      if (!result) {
        throw new Error('there is no solution');
      }
      const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](ProblmSubmissionRoute.SOLUTION);
      const updatedSolution = fixSolutionDates(result?.solution);
      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];
      // const travelers = getters[StoreGetters.GET_TRAVELERS_STRING];
      if (result && result.session_id) {
        const userId = getUserId();
        await ItineraryListModule.update(updatedSolution);
        commit(StoreMutations.SAVE_SOLUTION, {
          solution: {
            ...result,
            solution: updatedSolution,
            originalSolution: result.solution,
          },
        });
        if (needToSave) {
          const tripName = getters[StoreGetters.GET_SOLUTION_NAME];
          saveSolutionToMyTrips(
            result.session_id,
            userId,
            buildUserProfile(
              userId,
              availableTags.filter((x) => x.value),
              intersectionalFilters,
            ),
            tripName || result.destination?.name || '',
            true,
          );
        }
        commit(StoreMutations.ADD_SOLUTION_TO_TRIP, {tripId, solutionResponse: result});
      }
    },
    [StoreActions.RESCHEDULE_SOLUTION]: async ({commit, state, getters}, {start, end}) => {
      const oldResponse = state.solutionResponse;
      const oldSession = getters[StoreGetters.GET_SESSION_ID];
      const timezone = getters[StoreGetters.GET_SOLUTION_TIMEZONE];
      const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](ProblmSubmissionRoute.SOLUTION);
      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];

      let result = null;
      try {
        if (oldResponse) {
          commit(StoreMutations.SAVE_SOLUTION, {solution: null, soft: true});
          result = await resceduleSolution(oldSession, Math.floor(start / 1000), Math.floor(end / 1000), timezone);
        } else {
          throw new Error('go to catch');
        }

        const updatedSolution = fixSolutionDates(result?.solution);
        await ItineraryListModule.update(updatedSolution);
        commit(
          StoreMutations.SAVE_SOLUTION,
          updatedSolution
            ? {solution: {...result, solution: updatedSolution, originalSolution: result.solution}}
            : {solution: oldResponse},
        );

        if (result && result.session_id) {
          const userId = getUserId();
          const tripName = getters[StoreGetters.GET_SOLUTION_NAME];

          saveSolutionToMyTrips(
            result.session_id,
            userId,
            buildUserProfile(
              userId,
              availableTags.filter((x) => x.value),
              intersectionalFilters,
            ),
            tripName || result.destination?.name || '',
            true,
          );
        }
      } catch (x) {
        console.error(x);
        await ItineraryListModule.update(oldResponse?.solution || null);
        commit(StoreMutations.SAVE_SOLUTION, {solution: oldResponse});
      }
      return result;
    },
    [StoreActions.UPDATE_ORIGIN]: async ({commit}, value: ProblemDestination | null) => {
      commit(StoreMutations.UPDATE_ORIGIN, value);
    },
    [StoreActions.UPDATE_DESTINATION]: async ({commit}, value: ProblemDestination | null): Promise<void> => {
      commit(StoreMutations.UPDATE_DESTINATION, value);
    },
    [StoreActions.SELECT_TRIP]: async ({commit}, value: string) => {
      commit(StoreMutations.SAVE_SELECTED_TRIP, value);
    },
    [StoreActions.ADD_FAVORITE]: ({commit, state}, value: TripAction[]) => {
      commit(StoreMutations.ADD_FAVORITE, value);
      return state.selectedTrip;
    },
    [StoreActions.TOGGLE_TRIP_TYPE]: ({commit}, tripType: string) => {
      commit(StoreMutations.TOGGLE_TRIP_TYPE, tripType);
    },
    [StoreActions.UPDATE_TRIP_CATEGORY]: ({commit, state}, value) => {
      commit(StoreMutations.UPDATE_TRIP_CATEGORY, value);
      // removing selected tags and adding selected category tags

      // @ts-ignore
      const tags = [...tripCategoryTagsList[value], ...tripFocusTagList[state.tripFocus]];
      const selectedTags = state.availableSolutionFilters.filter((x) => x.value === true);
      selectedTags.forEach((tag: FilterTag) => {
        commit(StoreMutations.TOGGLE_SOLUTION_TAG, {tag: {...tag, value: false}, categoryChange: true});
      });
      tags?.forEach((tag: FilterTag) => {
        commit(StoreMutations.TOGGLE_SOLUTION_TAG, {tag, categoryChange: true});
      });
    },
    [StoreActions.UPDATE_TRIP_FOCUS]: ({commit, state}, tripFocus: string) => {
      commit(StoreMutations.UPDATE_TRIP_FOCUS, tripFocus);
      const selectedTags = state.availableSolutionFilters.filter((x) => x.value === true);

      selectedTags.forEach((tag: FilterTag) => {
        commit(StoreMutations.TOGGLE_SOLUTION_TAG, {tag: {...tag, value: false}, categoryChange: true});
      });

      // @ts-ignore
      const tags = [...tripCategoryTagsList[state.tripCategory], ...tripFocusTagList[tripFocus]];

      tags?.forEach((tag: FilterTag) => {
        commit(StoreMutations.TOGGLE_SOLUTION_TAG, {tag, categoryChange: true});
      });
    },
    // [StoreActions.REMOVE_FAVORITE]: ({commit}, value: TripAction) => {
    //   commit(StoreMutations.REMOVE_FAVORITE, value);
    // },
    [StoreActions.ADD_MANUAL_ACTIVITY]: ({commit}, value: RecommendationContext) => {
      commit(StoreMutations.SAVE_MANUAL_ACTIVITY, value);
    },
    [StoreActions.DROP_MANUAL_ACTIVITIES]: ({commit}) => {
      commit(StoreMutations.DROP_MANUAL_ACTIVITIES);
    },
    [StoreActions.UPDATE_SOLUTION_NAME]: ({commit}, name) => {
      commit(StoreMutations.UPDATE_SOLUTION_NAME, name);
    },
    [StoreActions.DROP_SELECTIONS]: ({commit}) => {
      commit(StoreMutations.DROP_SELECTIONS);
    },
    [StoreActions.RESET_FILTERS]: ({commit}) => {
      commit(StoreMutations.RESET_FILTERS);
    },
    [StoreActions.SELECT_ALTERNATIVE]: async ({commit, state, getters}, payload: AlternativeActivityAction) => {
      const {problemId, solutionResponse: oldResponse} = state;
      const sessionId = getters[StoreGetters.GET_SESSION_ID];
      const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](ProblmSubmissionRoute.SOLUTION);
      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];
      // const travelers = getters[StoreGetters.GET_TRAVELERS_STRING];
      if (!oldResponse?.solution) {
        return null;
      }

      // commit(StoreMutations.SAVE_SOLUTION, null);
      try {
        const response = await submitAlternativeActivity(
          {
            activityId: payload.activityId,
            problemId,
            sessionId,
            solutionId: oldResponse.solution?.id,
          },
          payload.activity,
        );
        const updatedSolution = fixSolutionDates(response?.solution);
        await ItineraryListModule.update(updatedSolution);
        commit(
          StoreMutations.SAVE_SOLUTION,
          updatedSolution
            ? {solution: {...response, solution: updatedSolution, originalSolution: response.solution}}
            : {solution: oldResponse},
        );
        if (response && response.session_id) {
          const userId = getUserId();
          const tripName = getters[StoreGetters.GET_SOLUTION_NAME];
          saveSolutionToMyTrips(
            response.session_id,
            userId,
            buildUserProfile(
              userId,
              availableTags.filter((x) => x.value),
              intersectionalFilters,
            ),
            tripName || response.destination?.name || '',
            true,
          );
        }
        commit(StoreMutations.ADD_SOLUTION_TO_TRIP, {tripId: payload.tripId, solutionResponse: response});
      } catch {
        await ItineraryListModule.update(oldResponse.solution || null);
        commit(StoreMutations.SAVE_SOLUTION, {solution: oldResponse});
      }
    },
    [StoreActions.RESCHEDULE_ACTIVITY]: async ({commit, state}, payload: IRescheduleActivityRequest) => {
      const {solutionResponse: oldResponse} = state;
      if (!oldResponse?.solution) {
        return null;
      }
      try {
        const response = await rescheduleActivity({
          sessionId: payload.sessionId,
          problemId: payload.problemId,
          solutionId: payload.solutionId,
          activityId: payload.activityId,
          startTime: payload.startTime,
          endTime: payload.endTime,
          dinnerPreference: payload.dinnerPreference,
        });
        if (!response) {
          throw new Error('go catch');
        }

        const updatedSolution = fixSolutionDates(response?.solution);
        await ItineraryListModule.update(updatedSolution);
        commit(
          StoreMutations.SAVE_SOLUTION,
          updatedSolution
            ? {solution: {...response, solution: updatedSolution, originalSolution: response.solution}}
            : {solution: oldResponse},
        );
      } catch {
        await ItineraryListModule.update(oldResponse.solution || null);
        commit(StoreMutations.SAVE_SOLUTION, {solution: oldResponse});
      }
    },

    [StoreActions.DROP_TRIP_OPTIONS]: ({commit}) => {
      commit(StoreMutations.DROP_DEST_OPTIONS);
    },

    [StoreActions.LOAD_TRIP_OPTIONS]: async (
      {state, getters, commit},
      {route, trip, includeFlights},
    ): Promise<TripsWithExplanations> => {
      const {problemId} = state;
      const userId = getUserId();
      const origin = getters[StoreGetters.GET_ORIGIN];
      const destination: ProblemDestination = trip || getters[StoreGetters.GET_DESTINATION];

      // Denn: changed here from GET_TAGS_FOR_ROUTE to GET_ALL_SOLUTION_FILTERS, to work with tags user sets
      const availableTags: FilterTag[] = getters[StoreGetters.GET_ALL_SOLUTION_FILTERS];
      // const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](route);

      const budget: Price[] = getters[StoreGetters.GET_PRICE_BUDGET](route);
      const travelersInformation = getters[StoreGetters.GET_TRAVELERS_INFORMATION];
      const {start, end} = getters[StoreGetters.GET_START_END_DATES];
      const result = buildProblemDestination(origin, destination, availableTags, start, end);
      if (result && destination?.id) {
        const {origin, destination, selectedTags} = result;
        try {
          const tripsForDestination = await downloadDestinationTrips(
            problemId,
            userId,
            origin,
            destination,
            selectedTags,
            budget,
            travelersInformation,
            [],
            includeFlights,
          );
          commit(StoreMutations.SAVE_DEST_OPTIONS, {
            tripId: trip.id,
            trips: tripsForDestination.trips,
            recommendations: tripsForDestination.recommendations,
          });
          return tripsForDestination;
        } catch (e) {
          console.error(e);
        }
      }
      return {
        trips: [],
        explanations: [],
      };
    },

    [StoreActions.LOAD_TRIP_OPTIONS_BY_PROBLEM]: async (
      {commit},
      {problem, tripId},
    ): Promise<TripsWithExplanations> => {
      const tripsForDestination = await downloadDestinationTripsByProblem(problem);
      commit(StoreMutations.SAVE_DEST_OPTIONS, {tripId: tripId, trips: tripsForDestination.trips});
      return tripsForDestination;
    },

    [StoreActions.UPDATE_TRIP_PREFERENCES]: async ({dispatch, getters}): Promise<object> => {
      // prepare ids
      const userId = getUserId();
      const tripId = getters[StoreGetters.GET_SOLUTION].id;
      const sessionId = getters[StoreGetters.GET_SESSION_ID];

      // prepare origin & destination
      const {start, end} = getters[StoreGetters.GET_START_END_DATES];
      const origin = {...getters[StoreGetters.GET_ORIGIN], departure_timestamp: start};
      const destination: ProblemDestination = {...getters[StoreGetters.GET_DESTINATION], arrival_timestamp: end};

      // prepare tags
      const availableTags: FilterTag[] = getters[StoreGetters.GET_ALL_SOLUTION_FILTERS];
      // const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](ProblmSubmissionRoute.SOLUTION);
      const selectedTags = availableTags.filter((x) => x.value);
      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];
      // build profile object
      const profile = buildUserProfile(userId, selectedTags, intersectionalFilters);

      // create problem object with only fields required by API: origin, destination, profile
      const problem = {
        origin,
        destination,
        profile,
      } as AmexProblemUpdatePreferences;
      const result = await updateProblemPreferencesApi(problem, sessionId);

      // save updated soluton we get
      await dispatch(StoreActions.SAVE_SOLUTION, {tripId, result, needToSave: true});

      return result;
    },

    [StoreActions.UPDATE_TRIP_TRAVELERS]: async ({dispatch, getters}): Promise<object> => {
      // prepare ids
      const tripId = getters[StoreGetters.GET_SOLUTION].id;
      const sessionId = getters[StoreGetters.GET_SESSION_ID];

      // prepare origin & destination
      const {start, end} = getters[StoreGetters.GET_START_END_DATES];
      const origin = {...getters[StoreGetters.GET_ORIGIN], departure_timestamp: start};
      const destination: ProblemDestination = {...getters[StoreGetters.GET_DESTINATION], arrival_timestamp: end};

      const traveler_information = getTravelersInformation();

      // create problem object with only fields required by API: origin, destination, traveler_information
      const problemUpdateData = {
        origin,
        destination,
        traveler_information,
      } as AmexProblemUpdateTravelers;
      const result = await updateProblemTravelersInfoApi(problemUpdateData, sessionId);

      // save updated soluton we get
      await dispatch(StoreActions.SAVE_SOLUTION, {tripId, result, needToSave: true});

      return result;
    },

    [StoreActions.LOAD_NEARBY_PLACES]: async ({state, getters, commit}): Promise<NearbyTripOptions | null> => {
      const {problemId} = state;
      const userId = getUserId();
      const origin = getters[StoreGetters.GET_ORIGIN];
      const destination: ProblemDestination = getters[StoreGetters.GET_DESTINATION];
      const budget: Price[] = getters[StoreGetters.GET_PRICE_BUDGET](ProblmSubmissionRoute.DESTINATION);
      const availableTags: FilterTag[] = getters[StoreGetters.GET_ALL_SOLUTION_FILTERS];
      const travelersInformation = getters[StoreGetters.GET_TRAVELERS_INFORMATION];
      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];

      const {start, end} = getters[StoreGetters.GET_START_END_DATES];
      const result = buildProblemDestination(origin, destination, availableTags, start, end);
      if (result && destination?.id) {
        const {origin, destination, selectedTags} = result;
        try {
          const contextsForDestination = await downloadDestinationAlternatives(
            problemId,
            userId,
            origin,
            destination,
            selectedTags,
            budget,
            travelersInformation,
            intersectionalFilters,
          );

          const loc = contextsForDestination.contexts.map((x) => mapCandidatePoiItemToTripOption(x, 0, 0, []));
          const res = {
            contexts: loc,
            isDestAvailable: contextsForDestination.isDestAvailable,
          };
          commit(StoreMutations.SAVE_NEARBY_LOCATIONS, res);
          return res;
        } catch {}
      }
      return null;
    },
    // [StoreActions.CHECK_PROBLEM]: async ({state, commit, getters}, route): Promise<TripOption[]> => {
    //   const {problemId} = state;
    //   const userId = getUserId();
    //   const origin = getters[StoreGetters.GET_ORIGIN];
    //   const destination = getters[StoreGetters.GET_DESTINATION];
    //   const travelersInformation = getters[StoreGetters.GET_TRAVELERS_INFORMATION];

    //   const budget: Price[] = getters[StoreGetters.GET_PRICE_BUDGET](route);
    //   const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](route);

    //   const {start, end} = getters[StoreGetters.GET_START_END_DATES];
    //   const result = buildProblemDestination(origin, destination, availableTags, start, end);

    //   if (result) {
    //     const {origin, destination, selectedTags} = result;
    //     try {
    //       const resp = await checkSolutionSustanability(
    //         problemId,
    //         userId,
    //         origin,
    //         destination,
    //         selectedTags,
    //         budget,
    //         travelersInformation,
    //       );
    //       commit(StoreMutations.SET_SOLUTION_EVALUATION, resp);
    //     } catch {
    //       commit(StoreMutations.SET_SOLUTION_EVALUATION, false);
    //     }
    //   }
    //   return getters[StoreGetters.GET_IS_SOLUTION_SUSTANABLE];
    // },
    [StoreActions.LOAD_ALTERNATIVES]: async (/*{commit, getters}, {activityId, sort}*/) => {
      // const sessionId = getters[StoreGetters.GET_SESSION_ID];
      // const solution: ISolution = getters[StoreGetters.GET_SOLUTION];
      // try {
      //   const alternatives = getters[StoreGetters.GET_ALTERNATIVES](activityId);
      //   if (!alternatives) {
      //     commit(StoreMutations.SAVE_ALTERNATIVES, {
      //       activityId,
      //       solutionId: '',
      //       response: {
      //         alternatives: [],
      //         locations: [],
      //       },
      //     });
      //   }
      //   if (solution) {
      //     const response = await loadAlternatives(
      //       {
      //         problemId: solution.problem_id,
      //         sessionId,
      //         activityId,
      //         solutionId: solution.id,
      //       },
      //       sort,
      //     );
      //     commit(StoreMutations.SAVE_ALTERNATIVES, {
      //       activityId,
      //       solutionId: solution.id,
      //       response,
      //     });
      //     return response;
      //   }
      //   return alternatives.response;
      // } catch {
      //   return null;
      // }
    },

    [StoreActions.LOAD_RECOMMENDATION_ALTERNATIVES]: async ({commit, getters}, {activityId}) => {
      const solution: ISolution = getters[StoreGetters.GET_SOLUTION];
      try {
        const alternatives = getters[StoreGetters.GET_ALTERNATIVES](activityId);
        // if (!alternatives) {
        //   commit(StoreMutations.SAVE_ALTERNATIVES, {
        //     activityId,
        //     solutionId: '',
        //     response: {
        //       alternatives: [],
        //       locations: [],
        //     },
        //   });
        // }
        if (alternatives) {
          return alternatives;
        }
        const response = await loadAlternativeRecommendations({poi_id: activityId});
        commit(StoreMutations.SAVE_ALTERNATIVES, {
          activityId,
          solutionId: solution?.id,
          response,
        });
        return response;
      } catch {
        return null;
      }
    },

    [StoreActions.LOAD_RECOMMENDATION_DETAILS]: async (
      {state, commit, getters},
      {route, contextName, sort = SelectOptions.best_match},
    ): Promise<Dictionary<SuggestionPois[]> | null> => {
      const {problemId} = state;
      const userId = getUserId();
      // const contextName = getters[StoreGetters.GET_TRIP_CONTEXT];
      const origin = getters[StoreGetters.GET_ORIGIN];
      const destination = getters[StoreGetters.GET_DESTINATION];
      const budget: Price[] = getters[StoreGetters.GET_PRICE_BUDGET](route);
      const travelersInformation = getters[StoreGetters.GET_TRAVELERS_INFORMATION];
      const availableTags: FilterTag[] = getters[StoreGetters.GET_ALL_SELECTED_FILTERS]
        .map((x: FilterTag) => ({...x, value: true}))
        .reverse();

      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];

      const {start, end} = getters[StoreGetters.GET_START_END_DATES];
      const result = buildProblemDestination(origin, destination, availableTags, start, end);

      if (result && contextName) {
        commit(StoreMutations.SET_SOLUTION_RECOMMENDATIONS_LOADING, true);
        const {origin, destination, selectedTags} = result;
        // commit(StoreMutations.UPDATE_DETAILS_LOADING_STATE, 1);
        try {
          const recommendationContexts = await downloadRecommendationContent(
            travelersInformation,
            problemId,
            userId,
            origin,
            destination,
            selectedTags,
            contextName,
            budget,
            sort,
            intersectionalFilters,
          );
          const pois = getPoisFromRecommendations(recommendationContexts);
          AdditionalPoisModule.addPois(pois);
          commit(StoreMutations.SAVE_RECOMMENDATION_DETAILS, recommendationContexts);
          commit(StoreMutations.SET_SOLUTION_RECOMMENDATIONS_LOADING, false);
          return recommendationContexts;
        } catch {
        } finally {
          commit(StoreMutations.SET_SOLUTION_RECOMMENDATIONS_LOADING, false);
        }
      }
      return null;
    },
    [StoreActions.REMOVE_POI]: async ({state, commit, getters}, {activityId, isPoi}): Promise<void> => {
      const manualActivities = getters[StoreGetters.GET_MANUAL_ACTIVITIES];
      const manualPoi = manualActivities.find(
        // @ts-ignore
        (x: RecommendationContext) => x.id === activityId || x.source?.content?.id === activityId,
      );
      if (manualPoi) {
        return commit(StoreMutations.SAVE_MANUAL_ACTIVITY, manualPoi);
      }
      const oldResponse = state.solutionResponse;
      const oldSolution = getters[StoreGetters.GET_SOLUTION];
      const sessionId = getters[StoreGetters.GET_SESSION_ID];
      const availableTags: FilterTag[] = getters[StoreGetters.GET_TAGS_FOR_ROUTE](ProblmSubmissionRoute.SOLUTION);
      const intersectionalFilters = getters[StoreGetters.GET_INTERSECTIONAL_FILTERS];
      // const travelers = getters[StoreGetters.GET_TRAVELERS_STRING];
      if (!oldResponse) {
        return;
      }
      // commit(StoreMutations.SAVE_SOLUTION, null);
      try {
        const response = await removePOI(activityId, oldSolution.problem_id, sessionId, oldSolution.id, isPoi);
        const updatedSolution = fixSolutionDates(response?.solution);
        await ItineraryListModule.update(updatedSolution);
        commit(
          StoreMutations.SAVE_SOLUTION,
          updatedSolution
            ? {solution: {...response, solution: updatedSolution, originalSolution: response.solution}}
            : {solution: oldResponse},
        );
        if (response && response.session_id) {
          const userId = getUserId();
          const tripName = getters[StoreGetters.GET_SOLUTION_NAME];
          saveSolutionToMyTrips(
            response.session_id,
            userId,
            buildUserProfile(
              userId,
              availableTags.filter((x) => x.value),
              intersectionalFilters,
            ),
            tripName || response.destination?.name || '',
            true,
          );
        }
      } catch {
        await ItineraryListModule.update(oldResponse.solution || null);
        commit(StoreMutations.SAVE_SOLUTION, {solution: oldResponse});
      }
    },
    [StoreActions.BLACK_LIST_RECOMMENDATION]: async ({commit}, poiId: string): Promise<void> => {
      commit(StoreMutations.BLACK_LIST_RECOMMENDATION, poiId);
    },
    [StoreActions.UPDATE_BUDGET_PREFERENCES]: async ({commit}, budget: BudgetPreferences): Promise<void> => {
      commit(StoreMutations.UPDATE_BUDGET_PREFERENCES, budget);
    },
  },
  /////////////////////////////////////////////////////////
  mutations: {
    [StoreMutations.UPDATE_DOMAIN_TAGS]: (state, domains: FilterTag[]) => {
      if (!state.availableSolutionFilters.length) {
        state.availableSolutionFilters = domains.map((x) => ({...x}));
      }
    },
    [StoreMutations.SAVE_INTERSECTIONAL_FILTERS]: (state, {category, filter}) => {
      const cat:
        | UserActivityCategoryEnum.ACCOMMODATION
        | UserActivityCategoryEnum.EXPERIENCE
        | UserActivityCategoryEnum.DINING = category;
      const filters = state[cat];
      const f = filters.find((x) => x.title === filter.title);
      // eslint-disable-next-line
      f!.value = filter.value;
      state[cat] = [...state[cat]];
    },
    [StoreMutations.SAVE_ALTERNATIVES]: (state, value: AlternativesMutationObj) => {
      if (!state.alternatives) {
        state.alternatives = {};
      }
      state.alternatives = {
        ...state.alternatives,
        [value.activityId]: value,
      };
    },
    [StoreMutations.SET_AVAILABLE_TRIP_OPTIONS]: (state, value: Trip[]) => {
      state.availableTripOptions = value;
    },
    [StoreMutations.REMOVE_MISSING_FILTER]: (state, id: string) => {
      state.initiallySelectedFilters = state.initiallySelectedFilters.filter((x) => x.id !== id);
    },
    [StoreMutations.SET_MISSING_FILTERS]: (state, {filters, travelersFilter, budget}) => {
      state.initiallySelectedFilters = filters;
      if (travelersFilter) {
        const adults = travelersFilter.adults || 1;
        const children = (travelersFilter.children || 0) + (travelersFilter.infants || 0);
        const rooms = travelersFilter.rooms || 0;
        const infantTypes = travelersFilter.infant_types || [];
        const under2 = infantTypes.length || 0;
        const childrenAges = travelersFilter.child_ages || [];
        const ages = childrenAges.reduce((res: Record<number, string>, x: number, index: number) => {
          res[index] = x.toString();
          return res;
        }, {});

        for (let i = childrenAges.length; i < childrenAges.length + under2; i++) {
          ages[i] = 'Under 2';
        }
        const seating = childrenAges.reduce((res: Record<number, string>, x: number, index: number) => {
          res[index] = 'In Seat';
          return res;
        }, {});
        let j = 0;
        for (let i = childrenAges.length; i < childrenAges.length + under2; i++) {
          seating[i] = infantTypes[j] === 'IN_SEAT' ? 'In Seat' : 'In Lap';
          j++;
        }
        const solutionTravelers: TravelersFilterValue = {
          filter: {
            adults: adults === 1 ? '1 Adult' : `${adults} Adults`,
            rooms: rooms === 1 ? '1 Room' : `${rooms} Rooms`,
            children:
              children === 1
                ? '1 Child'
                : children === 0
                ? travlersDefaultValue.filter.children
                : `${children} Children`,
          },
          age: ages,
          seating,
        };

        state.solutionTravelers = solutionTravelers;
      } else {
        state.solutionTravelers = {
          ...travlersDefaultValue,
          filter: {
            ...travlersDefaultValue.filter,
            adults: '1 Adult',
          },
        };
      }

      if (budget) {
        const budgetValue = {
          ...budgetDefultValue,
        };
        budget.forEach((x: {category: UserActivityCategoryEnum; amount: string | number}) => {
          switch (x.category) {
            case UserActivityCategoryEnum.ACCOMMODATION:
              budgetValue.stay = x.amount;
              break;
            case UserActivityCategoryEnum.TRANSPORTATION:
              budgetValue.flight = x.amount;
              break;
            case UserActivityCategoryEnum.EXPERIENCE:
              budgetValue.experience = x.amount as string;
              break;
            case UserActivityCategoryEnum.DINING:
              budgetValue.dine = x.amount as string;
              break;
          }
        });
        state.solutionBudget = budgetValue;
      } else {
        state.solutionBudget = budgetDefultValue;
      }
    },
    [StoreMutations.SET_SELECTED_THEME]: (state, value: string) => {
      state.selectedTheme = value;
    },
    [StoreMutations.TOGGLE_SOLUTION_TAG]: (state, tag: FilterTag) => {
      const toggledIndex = state.availableSolutionFilters.findIndex((x) => x.id === tag.id);
      if (toggledIndex >= 0) {
        state.availableSolutionFilters[toggledIndex].value = tag.value;
      }
      const toggledSelectedIndex = state.selectedSolutionFilters.findIndex((x) => x.id === tag.id);
      if (toggledSelectedIndex >= 0 && !tag.value) {
        state.selectedSolutionFilters.splice(toggledSelectedIndex, 1);
      }
      if (toggledSelectedIndex < 0 && tag.value) {
        state.selectedSolutionFilters.push(tag);
      }
    },
    [StoreMutations.ADD_FAVORITE]: (state, value: TripAction[]) => {
      if (!value.length) {
        return;
      }

      const trip = value.find((x) => x.tripId);
      const tripId = trip?.tripId || '';
      // const old = state.favorites[tripId] || [];
      const newItems: MinRecommendation[] = value.map((x) => {
        return {
          ...x.recommendation,
          intent: x.intent,
          // categories: x.recommendation.categories.filter((y, index, self) => self.indexOf(y) === index),
        };
      });
      state.favorites = {...state.favorites, [tripId]: [...newItems]};
    },
    [StoreMutations.UPDATE_ORIGIN]: (state, value: ProblemDestination | null) => {
      state.origin = value;
      // const myTrips = state.myTrips || [];
      // const relatedTrip = myTrips.find((x) => x.trip.id === state.selectedTrip);
    },
    [StoreMutations.UPDATE_SOLUTON_LOADING_STATE]: (state, value: boolean) => {
      state.isSolutionLoading = value;
    },
    [StoreMutations.SAVE_MANUAL_ACTIVITY]: (state, value: RecommendationContext) => {
      const isPresent = (state.manualActivities || []).some((x) => x.id === value.id);
      if (isPresent) {
        state.manualActivities = (state.manualActivities || []).filter((x) => x.id !== value.id);
      } else {
        state.manualActivities = [...(state.manualActivities || []), value];
      }
    },
    [StoreMutations.DROP_MANUAL_ACTIVITIES]: (state) => {
      state.manualActivities = [];
    },
    [StoreMutations.UPDATE_DESTINATION]: (state, value: ProblemDestination | null) => {
      state.destination = value;
    },
    [StoreMutations.TOGGLE_TRIP_TYPE]: (state, value: string) => {
      state.tripType = value;
    },
    [StoreMutations.UPDATE_TRIP_CATEGORY]: (state, value) => {
      state.tripCategory = value;
    },
    [StoreMutations.UPDATE_TRIP_FOCUS]: (state, value: string) => {
      state.tripFocus = value;
    },
    [StoreMutations.SAVE_SELECTED_TRIP]: (state, value: string) => {
      state.selectedTrip = value;
    },
    [StoreMutations.DROP_SELECTIONS]: (state) => {
      state.selectedTrip = '';
      state.availableSolutionFilters = [];
      state.manualActivities = [];
      state.favorites = {};
      state.problemId = '';
      state.isSolutionLoading = true;
      state.solutionResponse = null;
      state.origin = {...defaultOrigin};
      state.destination = {...defaultDestination};
    },
    [StoreMutations.DROP_FAVORITES]: (state, tripId?: string) => {
      if (!tripId) {
        state.favorites = {};
        return;
      }
      state.favorites = {
        ...state.favorites,
        [tripId]: [],
      };
    },
    [StoreMutations.RESET_FILTERS]: (state) => {
      state.selectedTrip = '';
      // state.recommendations = [];
      // state.availableTags = state.availableTags.map((x) => ({...x, value: false}));
      state.availableSolutionFilters.forEach((x) => (x.value = false));
      state.manualActivities = [];
      // state.favorites = {};
      state.problemId = '';
      state.isSolutionLoading = true;
      state.solutionResponse = null;
      // state.arrivalDate = 0;
      // state.departureDate = 0;
      state.origin = {...defaultOrigin};
      state.destination = {...defaultDestination};
      // state.isDetailsLoading = 0;
      // state.points = 0;
      // state.adults = 1;
      // state.children = 0;
      // state.infants = 0;
    },
    [StoreMutations.SAVE_RECOMMENDATION_DETAILS]: (state, value: Dictionary<SuggestionPois[]>) => {
      state.recommendationDetails = value;
    },
    [StoreMutations.SAVE_SOLUTION_VERSIONS]: (state, {tripId, versions}) => {
      state.alternativeSolutions = {
        ...(state.alternativeSolutions || {}),
        [tripId]: versions,
      };
    },
    [StoreMutations.UPDATE_SOLUTION_NAME]: (state, name: string) => {
      state.solutionName = name;
    },
    [StoreMutations.SET_MY_TRIPS]: (state, payload) => {
      state.myTrips = payload;
    },
    [StoreMutations.SAVE_SOLUTION]: (state, {solution, soft}) => {
      state.solutionResponse = solution as ExtendedSolutionResponse;
      const activities: Activity[] = solution?.solution?.activities || [];
      activities.forEach(({id, booked}) => {
        state.bookedActivities = state.bookedActivities || {};
        state.bookedActivities = {
          ...state.bookedActivities,
          [id]: booked,
        };
      });
      
      const pois = activities
        .filter((x) => !!x?.source?.content && (x.source.content as CandidatePoiItem).location)
        .map((x) => ({
          ...x?.source?.content,
          id: (x.source.content as CandidatePoiItem).id,
          images: (x.source.content as CandidatePoiItem).images,
          contexts: (x.source.content as CandidatePoiItem).contexts,
          categories: (x.source.content as CandidatePoiItem).categories,
          description: (x.source.content as CandidatePoiItem).description,
          source_id: (x.source.content as CandidatePoiItem).source_id,
          name: (x.source.content as CandidatePoiItem).name,
          scheduled_start_time: x.scheduled_start_time,
          scheduled_end_time: x.scheduled_end_time,
          curated: !!x.spec?.curated,
          matchedFilters: [],
          context: x.category,
          offers: [],
          intent: TripIntent.COULD_SEE,
          recommendations: [], 
          location: (x.source.content as CandidatePoiItem).location,
          start_timestamp: (x.source.content as CandidatePoiItem).start_timestamp, 
          end_timestamp: (x.source.content as CandidatePoiItem).end_timestamp,
          sourced_data: (x.source.content as CandidatePoiItem).sourced_data,
        })) as RecommendationsContextWithOffers[];
      AdditionalPoisModule.addPois(pois);
      if (!solution && !soft) {
        state.solutionName = '';
        state.recommendationDetails = {};
        if (state.solutionStart < new Date().valueOf() || state.solutionEnd < new Date().valueOf()) {
          state.solutionEnd = 0;
          state.solutionStart = 0;
        }
        state.solutionBudget = {...budgetDefultValue};
        state.solutionBudget = {...budgetDefultValue};
      }
      state.isSolutionLoading = false;
    },
    [StoreMutations.SET_BOOKING_STATUS]: (state, {activityId, status}) => {
      state.bookedActivities = state.bookedActivities || {};
      state.bookedActivities = {
        ...state.bookedActivities,
        [activityId]: status,
      };
    },
    [StoreMutations.ADD_SOLUTION_TO_TRIP]: (state, {tripId, solutionResponse}) => {
      const trip = state.myTrips.find((x) => x.trip?.id === tripId);
      const originalAccomodation = solutionResponse?.solution?.activities?.find(
        (x: Activity) => x.category === UserActivityCategoryEnum.ACCOMMODATION,
      );
      if (trip) {
        trip.solutionResponse = solutionResponse;
        trip.solutionUpdates = [];
        trip.alternativeActivities = null;
        trip.originalAccommodation = originalAccomodation || null;
      }
      state.myTrips = [...state.myTrips];
    },
    [StoreMutations.SAVE_SOURCE_POI]: (state, poi: RecommendationContext) => {
      state.sourcePOIs = [poi];
    },
    [StoreMutations.SAVE_TRIP_PRICE]: (state, price: Price[]) => {
      state.tripPrice = price;
    },
    [StoreMutations.SAVE_TRIP_THEMES]: (state, ssuggestions: SuggestionGroup[]) => {
      state.tripSuggestions = ssuggestions;
    },
    [StoreMutations.UPDATE_GROUP_BUDGET]: (state, budget: BudgetFilterValue) => {
      state.solutionBudget = budget;
    },
    [StoreMutations.UPDATE_SOLUTION_TRAVELERS]: (state, travelers) => {
      state.solutionTravelers = travelers;
      sessionStorage.setItem('travelers-filter', JSON.stringify(travelers));
    },
    [StoreMutations.UPDATE_DEST_BUDGET]: (state, budget: BudgetFilterValue) => {
      state.solutionBudget = budget;
    },
    [StoreMutations.UPDATE_SOLUTION_IMG]: (state, url: string) => {
      state.solutionImg = url;
    },
    [StoreMutations.UPDATE_DEST_NAME]: (state, name: string) => {
      state.destName = name;
    },
    [StoreMutations.SAVE_THEME_TRIPS]: (state, options: TripWithPois[]) => {
      state.themeTrips = options;
    },
    [StoreMutations.UPDATE_SOLUTION_DATES]: (state, {start, end}) => {
      state.solutionStart = start;
      state.solutionEnd = end;
    },
    [StoreMutations.UPDATE_SOLUTION_BUDGET]: (state, budget: BudgetFilterValue) => {
      state.solutionBudget = budget;
    },
    [StoreMutations.UPDATE_SELECTED_SOLUTION_FILTERS]: (state, filters: FilterTag[]) => {
      state.selectedSolutionFilters = filters;
    },
    [StoreMutations.SET_TRIP_CONTEXT]: (state, context: string) => {
      state.tripContext = context;
    },
    [StoreMutations.SET_SOLUTION_EVALUATION]: (state, isSustanable: boolean) => {
      state.isSolutionSustanable = isSustanable;
    },
    [StoreMutations.SAVE_NEARBY_LOCATIONS]: (state, payload: NearbyTripOptions) => {
      state.nearbyLocations = payload;
    },
    [StoreMutations.SAVE_DEST_OPTIONS]: (state, {tripId, trips, recommendations}) => {
      const updatedTripRecommendations = {...state.destOptions.recommendations, [tripId]: recommendations};

      state.destOptions = {
        ...state.destOptions,
        [tripId]: trips,
        recommendations: updatedTripRecommendations,
      };
    },
    [StoreMutations.DROP_DEST_OPTIONS]: (state) => {
      state.destOptions = {};
    },
    [StoreMutations.BLACK_LIST_RECOMMENDATION]: (state, poiId) => {
      const oldValue = state.recommendationsBlackList ? Array.from(state.recommendationsBlackList) : [];
      state.recommendationsBlackList = new Set(oldValue);
      state.recommendationsBlackList.add(poiId);
    },
    [StoreMutations.SET_SOLUTION_RECOMMENDATIONS_LOADING]: (state, value) => {
      state.isRecommendationsLoading = value;
    },
    [StoreMutations.UPDATE_BUDGET_PREFERENCES]: (state, value) => {
      state.budgetPreferences = value;
    },
    reset: () => {},
  },
};
